import { useTranslation } from 'react-i18next';

import { FormTextField } from '~/components/atoms/form-fields/FormTextField';
import ContentQRBuilderHeader from '~/components/builder/ContentQRBuilderHeader';
import NameAndOrganizationBlock from '~/components/builder/NameAndOrganizationBlock';
import QrTypeTopCard from '~/components/builder/QrTypeTopCard';
import Accordion from '~/components/ui/Accordion/Accordion';
import { QRCODE_STATIC_TYPE } from '~/constants/qr-code';
import CreateQRContentBlockLayout from '~/pages/CreateQR/components/CreateQRContentBlockLayout/CreateQRContentBlockLayout';
import { StyledContentContainer, StyledFormContainer } from '~/pages/qrBuilder/p-static/commonStyled';
// import PasswordProtectionBlock from '~/components/builder/PasswordProtectionBlock';

export const StaticEmailForm = () => {
  const { t } = useTranslation();

  return (
    <StyledFormContainer>
      <ContentQRBuilderHeader />
      <QrTypeTopCard type={QRCODE_STATIC_TYPE.EMAIL} />
      <CreateQRContentBlockLayout defaultExpanded type="basicInfo">
        <Accordion
          defaultExpanded
          variant="child"
          hideBottomBorder
          summary={t('staticQrTemplates:email:content:title')}
          details={
            <StyledContentContainer>
              <FormTextField name="email" fullWidth label={t('other:email')} inputProps={{ maxLength: 254 }} />
              <FormTextField name="subject" fullWidth label={t('other:subject')} inputProps={{ maxLength: 100 }} />
              <FormTextField
                name="message"
                fullWidth
                label={t('other:message')}
                inputProps={{ maxLength: 200 }}
                minRows={3}
                multiline
              />
            </StyledContentContainer>
          }
        />
      </CreateQRContentBlockLayout>
      <NameAndOrganizationBlock isStatic />
      {/*<PasswordProtectionBlock />*/}
    </StyledFormContainer>
  );
};
